import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, ViewChild, afterEveryRender } from '@angular/core';
import { IonicModule, LoadingController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { Analysis, BeerProfileRequest, BeerStat, SearchCharacteristicWithType, SearchType, AnalysisItem, LocalCharacteristic, Venue, SimilarBeerRequest, BaseFlavors} from "../../models/models";
import { AnalysisServiceProvider } from '../../providers/analysis-service/analysis-service';
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { UserDataProvider } from '../../providers/user-data/user-data';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AnalysisHolderProvider } from '../../providers/analysis-holder/analysis-holder';
import { RefdataProvider } from '../../providers/refdata/refdata';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { AppEventService } from '../../app/app-events';
import { SimilarBeersComponent } from '../similar-beers/similar-beers';
import { BeerSpiderComponent } from '../beer-spider/beer-spider';
import { BeerCcComponent } from '../beer-cc/beer-cc';
import { FlavorSliderAnalysisComponent } from '../flavor-slider/flavor-slider-analysis';
import { BeerHiveComponent } from '../beer-hive/beer-hive';
import { BeerIbaComponent } from '../beer-iba/beer-iba';
import { BeerAromasComponent } from '../beer-aromas/beer-aromas';
import { RatingBarComponent } from '../rating-bar/rating-bar';
import { WishlistButtonComponent } from '../wishlist-button/wishlist-button';
import { CommonModule } from '@angular/common';
import { MyNotesComponent } from '../my-notes/my-notes';
import { FormsModule } from '@angular/forms';
import { BeerAnalysisGroupComponent } from '../beer-analysis-group/beer-analysis-group';

enum TAB_MODE {
  MY = "my",
  GROUP = "group",
  BEERHIVE = "beerhive",
  BREWER = "brewer",
  SIMILAR_BEERS = "similar_beers"
}
enum SUB_TAB_MODE {
  NONE = "none",
  FLAVOR = "flavor",
  MOUTHFEEL = "mouthfeel",
  RATINGNOTES = "rating_notes",
  SUMMARY = "summary"
}

/**
 * Generated class for the BeerAnalysisComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'beer-analysis',
  templateUrl: 'beer-analysis.html',
  styleUrls: ['./beer-analysis.scss'],
  standalone: false,
  imports: [
    IonicModule,
    TranslateModule,
    SimilarBeersComponent,
    BeerSpiderComponent,
    BeerCcComponent,
    FlavorSliderAnalysisComponent,
    BeerHiveComponent,
    BeerIbaComponent,
    BeerAromasComponent,
    RatingBarComponent,
    WishlistButtonComponent,
    CommonModule,
    FormsModule,
    MyNotesComponent,
    BeerAnalysisGroupComponent
  ]
})

export class BeerAnalysisComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  /*
   *  attributes to manage the gui appearance
   */
  loading: any = null; // will contain the "loading" gui element reference

  tab_myActive: boolean = false;
  tab_groupActive: boolean = true;
  tab_similarActive: boolean = false;

  subtab_flavorActive: boolean = true;
  subtab_mouthfeelActive: boolean = false;
  subtab_summaryActive: boolean = false;
  subtab_ratingNotesActive: boolean = false;

  bShouldShow: boolean;
  saveActive: boolean = false;

  mustExecuteAfterEveryRender: boolean = false;

  /*
   *  the model: beerID and analysis objects
   */
  theBeerID: string;
  private selectedVenue: Venue = null;

  /*
   * the internal state: which analysis are we working with
   */
  private currentAnalysisInstance: string = null; // can be "beerhive", "my", "brewer"

  // translation objects
  wishlistlabel: string;

  /*
   *  other local attributes
   */
  prevBeerID: string;

  @Input()
  set beerID(bID: string) {
    this.theBeerID = bID;
    this.updateBeerID(bID);
  }
  get beerID() {
    return this.theBeerID;
  }

  private postAnalysisSubscription: any;
  private showBeerAnalysisSubscription: any;
  private wishlistPresentSubscription: any;
  private analyseColourInputSubscription: any;
  private analysisTotalexperienceSubscription: any;
  private updateNotesSubscription: any;
  private saveBeerSubscription: any;
  venueSelectedSubscription: any;
  venueDeselectedSubscription: any;
  private showSaveButtonSubscription: any;


  constructor(
    private toastController: ToastController,
    private events: AppEventService,
    private analysisService: AnalysisServiceProvider,
    private locationService: LocationServiceProvider,
    private userData: UserDataProvider,
    private beerService: BeerServiceProvider,
    private bhutil: BhutilProvider,
    private loadingCtrl: LoadingController,
    private beerAnalysisHolder: AnalysisHolderProvider,
    private refdata: RefdataProvider,
    private translateService: TranslateService,
    private storage: Storage
  ) {

    this.wishlistlabel = translateService.instant('BEERANALYSIS.WISHLIST') + " +";
    this.prevBeerID = null;
    this.bShouldShow = true;

    //tabs
    this.tab_myActive = false;
    this.tab_groupActive = true;
    this.tab_similarActive = false;

    //subitems for "my"
    this.subtab_flavorActive = false;
    this.subtab_mouthfeelActive = false;
    this.subtab_ratingNotesActive = false;
    this.subtab_summaryActive = false;//was true

    this.wishlistPresentSubscription = (beerInWishlist: boolean) => {
      //console.log("[beer-analysis][beer in wishlist] " + beerInWishlist);
      if (beerInWishlist) {
        this.wishlistlabel = translateService.instant('BEERANALYSIS.WISHLIST') + ' -';
      }
      else {
        this.wishlistlabel = translateService.instant('BEERANALYSIS.WISHLIST') + ' +';
      }
    };
    this.events.subscribe("wishlist:present", this.wishlistPresentSubscription);

    this.showSaveButtonSubscription = (showSaveValue: boolean) => {
      console.log("[beer-analysis] SUB show:savebutton", showSaveValue);
      this.updateShowSaveButton(showSaveValue);
    };
    this.events.subscribe("show:savebutton", this.showSaveButtonSubscription);

    this.showBeerAnalysisSubscription = (newbeer: any) => {
      console.log("[beer-analysis.showBeerSubscription] new beer received: " + newbeer.id);
      // needed???
      this.clearTransferObjectsAndModel();

      // 2 Fill the model
      // 2A if the beer profile is not yet loaded, load the beer profile
      // 2B if the beer profile is already loaded, switch the analysisHolder to the beer
      this.updateBeerID(newbeer.id);

      if (this.beerAnalysisHolder.hasBeer(this.theBeerID)) {
        console.log("Beeranalysiscomponent.showBeerSubscription: switch to beer " + this.theBeerID);
        this.beerAnalysisHolder.switchToBeer(this.theBeerID);
        this.prevBeerID = this.theBeerID;  

        // determine which analysis instance to show first
        this.currentAnalysisInstance = this.initialAnalysisInstanceToShow();

        // 3 Update the GUI elements, fill the transfer objects and publish the updates to the GUI
        this.updateView();

      }
      else {
        console.log("BeeranalysisComponent.showBeerSubscription: BEER NOT PRESENT for beerId " + this.theBeerID);
      }
    };
    this.events.subscribe("similar-beers:show:beer-analysis", this.showBeerAnalysisSubscription);
    this.events.subscribe("beer-detail:show:beer-analysis", this.showBeerAnalysisSubscription);

    this.saveBeerSubscription = () => {
      //debugger;
      this.saveAnalysis();
    };
    this.events.subscribe("save:beer", this.saveBeerSubscription);
/*
    this.venueSelectedSubscription = (venue: Venue) => {
      console.log("my-analyses - noticed filter veneu changed to:", venue.id);
      this.selectedVenue = venue;
      this.refreshSimilarBeers();
    };
    this.events.subscribe("venue:selected", this.venueSelectedSubscription);

    this.venueDeselectedSubscription = () => {
      console.log("my-analyses - noticed filter veneu changed to: null");
      this.selectedVenue = null;
      this.refreshSimilarBeers();
    };
    this.events.subscribe("venue:deselected", this.venueDeselectedSubscription);
    */
    this.mustExecuteAfterEveryRender = false;
    afterEveryRender(() => {
      // This executes specifically after every DOM update
      if (this.mustExecuteAfterEveryRender) {
        console.log("[beer-analysis] afterEveryRender effectively firing")
        this.mustExecuteAfterEveryRender = false;
        this.showCurrentAnalysis();
      }
    });

  }
  private clearTransferObjectsAndModel() {
    this.wishlistlabel = this.translateService.instant('BEERANALYSIS.WISHLIST') + ' +';

    // inform beer-hive component
    this.events.publish("clear:analysis", true);
    this.updateShowSaveButton(false);

    this.beerAnalysisHolder.shouldCheck = false;
  }

  // determine which group to show after loading the analysesfrom the server
  initialAnalysisInstanceToShow(): string {
    if (this.beerAnalysisHolder.hasBeerhiveAnalysis())
      return "beerhive";
    else
      return "my";
  }

  ionViewWillEnter() {
    console.log("beer-analysis - ionViewWillEnter called");
    if (this.refdata.isAndroid()) {
      console.log('setting fixed position dynamically for android');
      let saveButtonEl: HTMLElement = document.getElementById('save');
      saveButtonEl.style.position = 'fixed';
      // critcontainerEl.style.zIndex = '100';
    }
  }

  ngAfterViewInit() {
    console.log("[beer-analysis] ngAfterViewInit called");
    if (this.beerAnalysisHolder.hasActiveBeer()) {
      console.log("[beer-analysis] ngAfterViewInit has active beer, showing current analysis");
      this.showCurrentAnalysis();
      // Update Analysis view elements
      // this.mustExecuteAfterEveryRender = true;
    }
    else {
      console.log("[beer-analysis] ngAfterViewInit has no active beer, not showing current analysis");
    }

    // Update Analysis view elements
    // - update transfer objects and send event

    /*this.storage.get('selected-venue').then((venue) => {
      // First read the selected venue from storage
      let venueJSON = JSON.parse(venue);
      if (venueJSON != null) {
        this.selectedVenue = venueJSON;
        console.log("[my-analyses] - currently venue with id selected: " + venueJSON.id);
      }
    });*/
  }

  updateShowSaveButton(showSaveValue: boolean) {
    this.saveActive = showSaveValue;
  }

  dismissLoading() {
    if (this.loading != null) {
      this.loading.dismiss();
      this.loading = null;
    }
  }
/*
  refreshSimilarBeers() {
    console.log("[beer-analysis] requestSimilarBeers()");
    let latitude = this.locationService.latitude;
    let longitude = this.locationService.longitude;

    this.userData.getUserID()
      .then((userID) => {
        let similarBeerRequest = new SimilarBeerRequest(userID, latitude, longitude, this.theBeerID, (this.selectedVenue ? this.selectedVenue.id : null));

        if (this.loading == null) {
          this.loading = this.loadingCtrl.create({
            message: this.translateService.instant('GENERAL.PLEASE_WAIT')
          });

          this.loading.present().then(() => {
            setTimeout(() => {
              this.dismissLoading();
            }, 5000);

            this.beerService.getSimilarBeers(similarBeerRequest).subscribe(
              resp => {
                console.log("[beer-analysis] getSimilarBeers responded 200!");
                this.beerAnalysisHolder.setSimilarBeers(this.theBeerID, null, resp);
                this.events.publish("similarbeers", this.beerAnalysisHolder.getSimilarBeers());
                this.dismissLoading();
              },
              err => {
                console.log(err);
                this.dismissLoading();
              });

          });
        }
      });
  }
*/
  private tweakAnalysisBeforeViewing(currentAnalysis: Analysis) {
    //fix for bug (1) from BEERHIVE-97
    if (currentAnalysis.characteristicsvalues !== undefined) {
      for (let theItem of currentAnalysis.characteristicsvalues) {
        let k = theItem.name;
        let v = theItem.value;
        //debugger;
        if (k === "intensity") {
          //iValue = v;
          currentAnalysis.intensity = v;
        }
        else if (k === "body") {
          //bValue = v;
          currentAnalysis.body = v;
        }
        else if (k === "astringent" || k === "astringency") {
          // should have been astringent, not astringency (reopened BEERHIVE-92 in 1.0.7)
          //aValue = v;
          currentAnalysis.astringent = v;
        }
        else if (k === "alcohol") {
          //bValue = v;
          currentAnalysis.alcohol = v;
        }
        else if (k === "carbonation") {
          //aValue = v;
          currentAnalysis.carbonation = v;
        }
      }
    }
  }
  // show current analysis instance
  showCurrentAnalysis() {
    console.log("[beer-analysis.showCurrentAnalysis] called");

    let currentAnalysis: Analysis = this.beerAnalysisHolder.getAnalysis(this.currentAnalysisInstance);

    // notify subComponents
    if (this.currentAnalysisInstance == "my")
      this.events.publish("beer-analysis:show:beer-analysis-my");
    else
      this.events.publish("beer-analysis:show:beer-analysis-group");

    let currentAnalysisId = currentAnalysis.id;
    if (currentAnalysisId != undefined)
      this.analysisService.setAnalysisId(currentAnalysisId);
  }

  updateBeerID(bID: string) {
    console.log("updateBeerID() => " + bID);
    //debugger;
    this.theBeerID = bID;
    this.analysisService.setBeerId(bID);
  }

  ngOnInit() {
    // setting last caller page
    this.analysisService.setLastPage("analysis");
  }
  ngOnChanges() {
    console.log("[beer-analysis] [ngOnChanges] called");
  }

  ngOnDestroy() {

    console.log("[beer-analysis] [ngOnDestroy] DESTROYING for beer ID " + this.theBeerID + " and deactivating beer");

    this.beerAnalysisHolder.deactivateBeer();

    this.events.unsubscribe("post:analysis", this.postAnalysisSubscription);
    this.events.unsubscribe("similar-beers:show:beer-analysis", this.showBeerAnalysisSubscription);
    this.events.unsubscribe("beer-detail:show:beer-analysis", this.showBeerAnalysisSubscription);
    this.events.unsubscribe("wishlist:present", this.wishlistPresentSubscription);

    this.events.unsubscribe("analyse:colourInput", this.analyseColourInputSubscription);
    this.events.unsubscribe("update:notes", this.updateNotesSubscription);

    this.events.unsubscribe("save:beer", this.saveBeerSubscription);

    this.events.unsubscribe("venue:deselected", this.venueDeselectedSubscription);
    this.events.unsubscribe("venue:selected", this.venueSelectedSubscription);

    this.events.unsubscribe("show:savebutton", this.showSaveButtonSubscription);
  }

  private updateView() {

    // this should only be called when this.currentAnalysisInstance is already correctly set and analyses are loaded

    // Update GUI elements
    // - tab and subtab
    // - bottom group selector
    let subTabMode = SUB_TAB_MODE.NONE;
    if (this.currentAnalysisInstance == "my") {
      if (this.beerAnalysisHolder.hasLoadedMyAnalysis())
        subTabMode = SUB_TAB_MODE.SUMMARY;
      else
        subTabMode = SUB_TAB_MODE.FLAVOR;
    }
    this.setCurrentTabAndSubTab(this.currentAnalysisInstance, subTabMode);

    this.mustExecuteAfterEveryRender = true;
    // Update Analysis view elements
    // - update transfer objects and send event

    // Update similar beers
    // this.events.publish("similarbeers", this.beerAnalysisHolder.getSimilarBeers());
  }

  /*
   *. change handler to be called when the subcomponent becomes visible
   */
/*
  @ViewChild(BeerAnalysisMyComponent) set analysisMyComp(analysisMyComp: BeerAnalysisMyComponent) {
    console.log("[beer-analysis] set analysisMyComp");
    if (analysisMyComp) {
      console.log("[beer-analysis] set analysisMyComp exists");
      // Resolve any timing conflicts
      Promise.resolve().then(() => analysisMyComp.updateView());
    }
  }
  @ViewChild(BeerAnalysisGroupComponent) set analysisGroupComp(analysisGroupComp: BeerAnalysisGroupComponent) {
    console.log("[beer-analysis] set analysisGroupComp");
    if (analysisGroupComp && this.beerAnalysisHolder) {
      console.log("[beer-analysis] set analysisGroupComp exists");
      // Resolve any timing conflicts
      Promise.resolve().then(() => analysisGroupComp.updateView("beerhive"));
    }
  }
*/
  @ViewChild(SimilarBeersComponent) set similarBeersComp(similarBeersComp: SimilarBeersComponent) {
    console.log("[beer-analysis] set similarBeersComp");
    if (similarBeersComp) {
      console.log("[beer-analysis] set similarBeersComp exists");
      // Resolve any timing conflicts
      Promise.resolve().then(() => this.events.publish("similarbeers", this.beerAnalysisHolder.getSimilarBeers()));
    }
  }
  showMy() {
    this.currentAnalysisInstance = "my";
    this.updateView();
  }

  showBeerhiveGroup() {
    let targetAnalysisInstance = this.initialAnalysisInstanceToShow();

    if (targetAnalysisInstance == "my") {
      const toastProm = this.toastController.create({
        message: this.translateService.instant('BEERANALYSIS.THIS_BEER_HAS_NO_GROUP_ANALYSIS_YET'),
        duration: 3000,
        position: 'bottom'
      });
      toastProm.then((toast) => { toast.present() });
    }
    else { // there is a analysis for the current group
        this.currentAnalysisInstance = targetAnalysisInstance;
        this.updateView();
    }
  }

  showSimilarBeers() {
    this.setCurrentTabAndSubTab(TAB_MODE.SIMILAR_BEERS);
  }
  showVisualChart() {
    console.log("[beer-analysis] showVisualChart()");
    this.currentAnalysisInstance = "my";
    this.setCurrentTabAndSubTab(TAB_MODE.MY, SUB_TAB_MODE.FLAVOR);
  }

  showMouthfeelAromas() {
    console.log("[beer-analysis] showMouthfeelAromas()");
    this.currentAnalysisInstance = "my";
    this.setCurrentTabAndSubTab(TAB_MODE.MY, SUB_TAB_MODE.MOUTHFEEL);
  }

  showRatingNotes() {
    console.log("[beer-analysis] showRatingNotes()");
    this.currentAnalysisInstance = "my";
    this.setCurrentTabAndSubTab(TAB_MODE.MY, SUB_TAB_MODE.RATINGNOTES);
  }

  showMySummary() {
    console.log("[beer-analysis] showMySummary()");
    this.currentAnalysisInstance = "my";
    this.setCurrentTabAndSubTab(TAB_MODE.MY, SUB_TAB_MODE.SUMMARY);
  }

  setCurrentSubTab(subTabMode: string) {
    this.subtab_flavorActive = false;
    this.subtab_mouthfeelActive = false;
    this.subtab_ratingNotesActive = false;
    this.subtab_summaryActive = false;

    switch(subTabMode) {
      case SUB_TAB_MODE.FLAVOR:
        this.subtab_flavorActive = true;
        this.events.publish("set:shouldupdate", true);
        break;
      case SUB_TAB_MODE.MOUTHFEEL:
        this.subtab_mouthfeelActive = true;
        break;
      case SUB_TAB_MODE.RATINGNOTES:
        this.subtab_ratingNotesActive = true;
        break;
      case SUB_TAB_MODE.SUMMARY:
        this.subtab_summaryActive = true;
        break;
      default: // leave everything off
        break;
    }
  }
  setCurrentTabAndSubTab(tabMode: string, subTabMode: string = SUB_TAB_MODE.NONE) {
    console.log("[beer-analysis.setCurrentTabAndSubTab] setting tabMode " + tabMode + " and subtabMode " + subTabMode);

    // set all false and only activate the correct one
    this.tab_myActive = false;
    this.tab_groupActive = false;
    this.tab_similarActive = false;
    this.setCurrentSubTab(SUB_TAB_MODE.NONE);

    switch(tabMode) {
      case TAB_MODE.MY:
        this.tab_myActive = true;
        this.setCurrentSubTab(subTabMode);
        this.beerAnalysisHolder.shouldCheck = true;
        break;
      case TAB_MODE.GROUP:
      case TAB_MODE.BEERHIVE:
      case TAB_MODE.BREWER:
        this.tab_groupActive = true;
        this.beerAnalysisHolder.shouldCheck = false;
        break;
      case TAB_MODE.SIMILAR_BEERS:
        this.tab_similarActive = true;
        this.beerAnalysisHolder.shouldCheck = false;
        break;
    }
  }

  saveAnalysis() {
    //more or less similar to addOrModifyAnalysis
    //debugger;
    this.addOrModifyAnalysis();
  }
  addOrModifyAnalysis() {
    console.log("[beer-analysis].addOrModifyAnalysis() called");

    let myAnalysis: Analysis = this.beerAnalysisHolder.getMyAnalysis();
    
    if (this.beerAnalysisHolder.hasLoadedMyAnalysis()) {
      this.analysisService.updateAnalysis(myAnalysis, false).subscribe((resp: any) => {
      console.log("[beer-analysis].addOrModifyanalysis: RESPONSE - UPDATE ANALYSIS: " + this.bhutil.stringify(resp))
      let updatedAnalysisID = resp.analysisid;
      this.analysisService.setAnalysisId(updatedAnalysisID);

      // Update the analysis in the model
      this.beerAnalysisHolder.getMyAnalysis().id = resp.analysisid;
      let newLoadedAnalysis = this.beerAnalysisHolder.getMyAnalysis();
      this.beerAnalysisHolder.replaceMyAnalysis(newLoadedAnalysis);
      console.log("[beer-analysis].addOrModifyAnalysis(): updated analysis = ", this.beerAnalysisHolder.getMyAnalysis());

      // Show TOAST to informuser of successful update
      const toastProm = this.toastController.create({
        message: this.translateService.instant('BEERANALYSIS.YOUR_ANALYSIS_HAS_BEEN_UPDATED'),
        duration: 3000,
        position: 'bottom'
      });
      toastProm.then((toast) => { toast.present() });

      // Remove the save button
      this.events.publish("show:savebutton", false);

      console.log("beer-analysis - update complete!")
      
    }, err => {
      console.error("[beer-analysis] ERROR - UPDATE ANALYSIS! " + err);
      console.log(err)
    });
    }
    else { // there was no former loaded my-analysis, so create a new
      this.analysisService.addAnalysis(myAnalysis).subscribe((resp: any) => {
      console.log("[beer-analysis] RESPONSE - ADD ANALYSIS: " + this.bhutil.stringify(resp));
      //debugger;
      // Update the analysis in the model
      this.beerAnalysisHolder.getMyAnalysis().id = resp.analysisid;
      let newLoadedAnalysis = this.beerAnalysisHolder.getMyAnalysis();
      this.beerAnalysisHolder.replaceMyAnalysis(newLoadedAnalysis);
//      this.beerAnalysisHolder.replaceMyAnalysis(resp);
      console.log("[beer-analysis].addOrModifyAnalysis(): updated analysis = ", this.beerAnalysisHolder.getMyAnalysis());
      //store the analysis ID!
      let addedAnalysisID = resp.analysisid;
      this.analysisService.setAnalysisId(addedAnalysisID);

      // TOAST
      const toastProm = this.toastController.create({
        message: this.translateService.instant('BEERANALYSIS.YOUR_ANALYSIS_HAS_BEEN_ADDED'),
        duration: 3000,
        position: 'bottom'
      });

      toastProm.then((toast) => { toast.present() });

      // Remove the save button
      this.events.publish("show:savebutton", false);
      }, err => {
        this.analysisService.setAnalysisId(null);//aanpassing Koen
        console.error("[beer-analysis] ERROR - ADD ANALYSIS! " + err);
        console.error(err)
      });
    }
  }
}
